import { URLHelpers } from 'helpers/URLHelpers';

import { useWorkspaceConfig } from 'hooks/use-workspace-config';

const DEFAULT_HERO_IMAGE = URLHelpers.file('/images/stock/solar-hero.jpg');
const DEFAULT_HERO_VIDEO = URLHelpers.file('/videos/dcide-header.mp4');

export const useHeroMedia = () => {
    const { heroImageUrl } = useWorkspaceConfig();

    return {
        image: {
            src: heroImageUrl || DEFAULT_HERO_IMAGE,
            width: 1440,
            height: 1080,
        },
        video: heroImageUrl
            ? undefined
            : {
                  src: DEFAULT_HERO_VIDEO,
                  width: 3840,
                  height: 2160,
              },
    };
};
